export const NO_STATE = '';

export const APP = 'app';

export const LOGIN = 'login';
export const LOGOUT = 'logout';

export const PASSWORD_VALIDATION_REQUEST = 'login.request-validation';
export const PASSWORD_VALIDATION_SUBMIT = 'login.submit-validation';
export const PASSWORD_RESET = 'login.reset-password';

export const ACCOUNTCENTRE = 'account-centre';

export const BILLING = 'billing';


export const DELIVERIES = 'deliveries';
export const DELIVERIES_MAP = 'deliveries.map';
export const DELIVERIES_MAP_ORDER = 'deliveries.map.order';
export const DELIVERIES_MAP_REASSIGN = 'deliveries.map.reassign';
export const DELIVERIES_MAP_REDISPATCH = 'deliveries.map.redispatch';
export const DELIVERIES_MAP_REDISPATCH_ASSIGN = 'deliveries.map.redispatch.assign';
export const DELIVERIES_LIST = 'deliveries.list';
export const DELIVERIES_LIST_CREATE = 'deliveries.list.create';
export const DELIVERIES_LIST_CREATE_ASSIGN = 'deliveries.list.create.assign';
export const DELIVERIES_LIST_ASSIGN = 'deliveries.list.assign';
export const DELIVERIES_LIST_EXPORT = 'deliveries.list.export';
export const DELIVERIES_LIST_ORDER = 'deliveries.list.order';
export const DELIVERIES_LIST_REASSIGN = 'deliveries.list.reassign';
export const DELIVERIES_LIST_REDISPATCH = 'deliveries.list.redispatch';
export const DELIVERIES_LIST_REDISPATCH_ASSIGN = 'deliveries.list.redispatch.assign';
export const DELIVERIES_LOCATIONS = 'deliveries.locations';

export const DELIVERIES_SETTINGS = 'deliveries.settings';
export const DELIVERIES_SETTINGS_BRAND = 'deliveries.settings.brand';
export const DELIVERIES_SETTINGS_DISPATCH = 'deliveries.settings.dispatch';
export const DELIVERIES_SETTINGS_ALERTSANDNOTIFICATIONS = 'deliveries.settings.alerts-notifications';
export const DELIVERIES_SETTINGS_INTEGRATIONS = 'deliveries.settings.integrations';
export const DELIVERIES_SETTINGS_INTEGRATIONS_VIEW = 'deliveries.settings.integrations.view';
export const DELIVERIES_SETTINGS_INHOUSEDRIVERS = 'deliveries.settings.inhouse-drivers';
export const DELIVERIES_SETTINGS_MYDRIVERS = 'deliveries.settings.my-drivers';
export const DELIVERIES_SETTINGS_MYDRIVERS_CREATE = 'deliveries.settings.my-drivers.create';
export const DELIVERIES_SETTINGS_USERS = 'deliveries.settings.users';
export const DELIVERIES_SETTINGS_USERS_CREATE = 'deliveries.settings.users.create';
export const DELIVERIES_SETTINGS_API_KEYS = 'deliveries.settings.api-keys';

// TODO: Remove the ones below after completing implementation
export const DELIVERIES_SETTINGS_SUPPORTSETTINGS =
    'deliveries.settings.support-settings';
export const DELIVERIES_SETTINGS_CUSTOMERPOLICY = 'deliveries.settings.customer-policy';
export const DELIVERIES_SETTINGS_DELIVERYAREA = 'deliveries.settings.delivery-area';
export const DELIVERIES_SETTINGS_DISPATCHMODE = 'deliveries.settings.dispatch-mode';
export const DELIVERIES_SETTINGS_DRIVERPOSITIONS =
    'deliveries.settings.driver-positions';
export const DELIVERIES_SETTINGS_PICKUPNOTES = 'deliveries.settings.pickup-notes';
export const DELIVERIES_SETTINGS_PREPTIME = 'deliveries.settings.prep-time';
export const DELIVERIES_SETTINGS_ALERTSNOTIFICATIONS =
    'deliveries.settings.alerts-notifications';
export const DELIVERIES_SETTINGS_MULTIPLEDELIVERIES =
    'deliveries.settings.multiple-deliveries';

export const DELIVERIESPROMO = 'deliveries-promo';

export const DEVSUPPORT = 'dev-support'
export const DEVSUPPORT_DASHBOARD = 'dev-support.dahsboard';

export const ERROR = 'error';
export const ERROR_NOTFOUND = 'error.not-found';
export const ERROR_RESTRICTED = 'error.restricted';

export const LIVEVIEW = 'live-view';
export const LIVEVIEW_CREATE = 'live-view.create';
export const LIVEVIEW_CREATE_ASSIGN = 'live-view.create.assign';
export const LIVEVIEW_ORDER = 'live-view.order';
export const LIVEVIEW_ORDER_ASSIGN = 'live-view.order.assign';
export const LIVEVIEW_ORDER_REASSIGN = 'live-view.order.reassign';
export const LIVEVIEW_ORDER_REDISPATCH = 'live-view.order.redispatch';
export const LIVEVIEW_ORDER_REDISPATCH_ASSIGN = 'live-view.order.redispatch.assign';

export const LOCATIONS = 'locations';
export const LOCATIONS_LIST = 'locations.list';
export const LOCATIONS_LIST_CREATE = 'locations.list.create';
export const LOCATIONS_LIST_EDIT = 'locations.list.edit';

export const PROFILE = 'profile';
export const PROFILE_BASE = 'profile.base';
export const PROFILE_LOGINDETAILS = 'profile.login-details';
export const PROFILE_LOGINDETAILS_PHONEVERIFICATION = 'profile.login-details.phone-verification';
export const PROFILE_LOGINDETAILS_EMAILVERIFICATION = 'profile.login-details.email-verification';

export const REPORTS = 'reports';
export const REPORTS_DRIVERS = 'reports.drivers';
export const REPORTS_DRIVERS_EXPORT = 'reports.drivers.export';

export const REGISTRATION = 'registration';
export const REGISTRATION_BUSINESS = 'registration.business';

export const SETTINGS = 'settings';
